<section class="vm-row" [id]="data?.id">
  <h2 class="feature-title" *ngIf="data?.title">
    {{ data?.title }}
  </h2>
  <div *ngFor="let card of data?.items" class="vm-col-xs-6 vm-col-sm-3">
    <vm-feature-card
      (click)="onContinue(card?.uid || card?.ctas[0]?.targetContentSectionId)"
      [featureImage]="card?.image"
      [featureImageAltText]="card?.imageAltText">
      <p *ngIf="card?.title">{{ card?.title }}</p>
    </vm-feature-card>
  </div>
  <vm-markdown *ngIf="data?.copy" [data]="data?.copy" class="feature-footer"></vm-markdown>
</section>
